import React from 'react';
import { Layout } from 'antd';
import Header from '../../components/PageLayout/Header';
import SidebarWrapper from '../../components/PageLayout/Sidebar';
import ServicesContent from '../../components/PageFragments/Services';
import SEO from '../../components/Seo';

const Services = () => (
  <Layout className="outerPadding">
    <Layout className="container">
      <SEO
        title="Services"
        description="Hire Muneeb for robotics simulation, Sim2Real, URDF modeling, ROS 2 / Gazebo drone simulation and reinforcement-learning projects."
        path="/services"
        keywords={['Muneeb', 'Fiverr', 'Robotics Simulation', 'URDF', 'ROS 2', 'Gazebo', 'Reinforcement Learning', 'PX4', 'ArduPilot']}
      />
      <Header />
      <SidebarWrapper>
        <div className="marginTopTitle">
          <h1 className="titleSeparate">Services</h1>
        </div>
        <ServicesContent />
      </SidebarWrapper>
    </Layout>
  </Layout>
);

export default Services;
